import { ColumnsType } from "antd/es/table"
import { useDispatch, useSelector } from "react-redux"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { CashboxStatement } from "src/common/models/cashboxStatement"
import { PageCard } from "src/common/styles/styles"
import { SearchableTable } from "src/components/SearchableTable"
import { GET_CASHBOX_STATEMENT_RECORDS_API } from "src/features/CustomerPayment/state/actionTypes"
import { RootState } from "src/state/reducer"
import { summaryColumns, TABLE_COLUMNS } from "./config"
import { useEffect, useState } from "react"
import { getCashboxStmtRecordsApi } from "src/features/CustomerPayment/state/action"
import { DateRanges } from "src/components/SearchableTable/types"
import moment from "moment"
import dayjs from 'dayjs'
import { SystemConstants } from "src/common/constants"
import { SystemDescriptions } from "src/common/descriptions"
import { Button } from "antd"
import { formatToCurrency } from "src/common/util"
import useUserPermission from "src/hooks/useUserPermissions"
import { USER_SCOPES } from "src/hooks/UserPermission"

export type ReduxProps = {
    cashboxStatements?: CashboxStatement[],
    isGettingRecords: boolean
    cashboxBalance: number
}

export const CashboxStatementRecords = () => {
    const dispatch = useDispatch()
    const { validateUserScopeForPage } = useUserPermission()

    const [dateRanges, setDateRanges] = useState<DateRanges>({
        startDate: moment().format(SystemConstants.DATETIME_QUERY(true)),
        endDate: moment().format(SystemConstants.DATETIME_QUERY(false)),
    })

    const handleDateRangesChange = (dateRanges: DateRanges) => {
        setDateRanges({
            startDate: moment(dateRanges.startDate).format(SystemConstants.DATETIME_QUERY(true)),
            endDate: moment(dateRanges.endDate).format(SystemConstants.DATETIME_QUERY(false)),
        })
    }

    const fetchRecords = () => {
        dispatch(getCashboxStmtRecordsApi({
            dateFrom: dateRanges.startDate,
            dateTo: dateRanges.endDate,
        }))
    }

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.CASHBOX_STATEMENT_READ)
        fetchRecords()
    }, [])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        cashboxStatements: state.contractPayment.cashboxStmtRecords || [],
        isGettingRecords: serviceLoading(state, [GET_CASHBOX_STATEMENT_RECORDS_API]),
        cashboxBalance: state.contractPayment.cashboxBalance,
    }))

    const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CASHBOX_STATEMENTS

    const tblColumns: ColumnsType<CashboxStatement> = [
        ...TABLE_COLUMNS,
        // {
        //     title: "actions",
        //     dataIndex: ColumnsKeys.ACTIONS,
        //     key: ColumnsKeys.ACTIONS,
        //     align: searchableTableUtils.alignment.centerAlign,
        //     render: (_, record: ServiceDebitContract) => {
        //         const handleViewClick = (contractId: number) => {
        //             setSelectedAction("VIEW")
        //             dispatch(getServiceContractByIdApi(contractId))
        //         }

        //         const handleCreatePaymentClick = (contractId: number) => {
        //             setSelectedAction("CREATE_PAYMENT")
        //             dispatch(getContractDebitByIdApi(contractId))
        //         }

        //         return <Space size="middle">
        //             <Tooltip title={commonDescriptions.ACTIONS.VIEW} >
        //                 <Button type="primary" ghost shape="circle" size="small"
        //                     icon={<ProfileOutlined />}
        //                     onClick={() => handleViewClick(record.id!)}
        //                 />
        //             </Tooltip>
        //             <Tooltip title={"Registrar Pago"} >
        //                 <Button type="primary" ghost shape="circle" size="small"
        //                     icon={<CreditCardOutlined />}
        //                     onClick={() => handleCreatePaymentClick(record.id!)}
        //                 />
        //             </Tooltip>
        //         </Space>
        //     },
        // },
    ]

    const handleActionButtonClick = () => {
        fetchRecords()
    }

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
            extra={<Button color="default" variant="text">
                <b>{descriptions.BALANCE} </b> {formatToCurrency(reduxProps.cashboxBalance.toString())}
            </Button>}
        >
            <SearchableTable
                showSearch
                showLoader={reduxProps.isGettingRecords}
                items={reduxProps.cashboxStatements || []}
                tableColumns={tblColumns as any}
                searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
                summaryColumns={summaryColumns}
                showRangePicker
                rangePickerOnChange={handleDateRangesChange}
                rangePickerDefaultValues={[dayjs(), dayjs()]}
                actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                showActionButton
                actionButtonOnClick={handleActionButtonClick}
            />
        </PageCard>
    )
}
